import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { useParams, Link } from "react-router-dom";
import { useHistory } from "react-router-dom";


import dayjs from "dayjs";
import Select from "react-select";
import Radio from "@mui/material/Radio";
import makeAnimated from "react-select/animated";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";


import {
    getCompany,
    GetProjectsBasedOnUserId,
    createInvestmentObject
} from "../../../WorkSpace/Components/ApiServices/apiHandler";



import { Button } from "../../../myfin_v2/elements/Button";
import IRMenu from "./IRMenu"
import CustomDropdownIndicator from "../../../myfin_v2/elements/CustomDropdownIndicator";
import InputGroup from "../../../myfin_v2/elements/InputGroup";
import Sidebar from "../../../myfin_v2/elements/Sidebar";
import commoncss from "../../../myfin_v2/css/common.module.css";
import buttoncss from "../../../myfin_v2/css/button.module.css";
import investmentRegisterCss from "../../../myfin_v2/css/investmentRegister.module.css";
import { ReactComponent as PlusPrimaryIcon } from "../../../myfin_v2/assets/icons/plusprimary.svg";
import { ReactComponent as CalenderIcon } from "../../../myfin_v2/assets/icons/calender.svg";
import { ReactComponent as CrossGreyIcon } from "../../../myfin_v2/assets/icons/crossGrey.svg";
import { ReactComponent as LeftArrowIcon } from "../../../myfin_v2/assets/icons/left_arrow.svg";
import { ReactComponent as DotIcon } from "../../../myfin_v2/assets/icons/dot.svg";


export const customStyles = {
    control: (provided, state) => ({
        ...provided,
        backgroundColor: '#f4faf5',
        borderColor: '#c2e6d1',
        color: '#b3c0bd',
        boxShadow: state.isFocused ? '0 0 0 1px #c2e6d1' : 'none',
        borderWidth: '1px',
        borderRadius: '10px',
        '&:hover': {
            borderColor: '#b3c0bd',
        },
        minHeight: '38px',
        height: '38px',
    }),
    valueContainer: (provided) => ({
        ...provided,
        padding: '2px 8px',
        paddingTop: '1px',
    }),
    input: (provided) => ({
        ...provided,
        color: '#b3c0bd',
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#b3c0bd',
        fontSize: '14px',
    }),
    singleValue: (provided) => ({
        ...provided,
        color: '#4d6d64',
        fontSize: '14px',
    }),
    multiValue: (provided) => ({
        ...provided,
        backgroundColor: '#e0f5e9',
        borderRadius: '0.25rem',
        border: '1px solid #c2e6d1',
        width: 'fit-content',
    }),
    multiValueLabel: (provided) => ({
        ...provided,
        color: '#4d6d64',
    }),
    multiValueRemove: (provided) => ({
        ...provided,
        color: '#b3c0bd',
        ':hover': {
            backgroundColor: '#c2e6d1',
            color: '#4f665f',
        },
    }),
    indicatorsContainer: (provided) => ({
        ...provided,
        color: '#b3c0bd',
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        color: '#1A4338',
        fontWeight: 400,
        ':hover': {
            color: '#1A4338',
            fontWeight: 400,
        },
    }),
    clearIndicator: (provided) => ({
        ...provided,
        color: '#b3c0bd',
        ':hover': {
            color: '#4f665f',
        },
    }),
    menu: (provided) => ({
        ...provided,
        backgroundColor: '#ffffff',
        border: '1px solid #c2e6d1',
        borderRadius: '6px',
        boxShadow: '0 0 0 1px #c2e6d1',
        marginTop: '6px',
        zIndex: 10,
    }),
    menuList: (provided) => ({
        ...provided,
        padding: '4px',
        borderRadius: '6px',
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected
            ? '#c2e6d1'
            : state.isFocused
                ? '#f4faf5'
                : 'transparent',
        color: '#4f665f',
        padding: '10px 12px',
        cursor: 'pointer',
        fontSize: '14px',
        borderRadius: '8px',
        // margin: '4px 6px',
    }),
    noOptionsMessage: (provided) => ({
        ...provided,
        color: '#b3c0bd',
        padding: '8px 12px',
    }),
};

const CreateInvestment = () => {


     const { registerid } = useParams();
     
    console.log("✅ Register ID:", registerid);
    const animatedComponents = makeAnimated();
    const user_id = localStorage.getItem("user_id");

    const companyRelationShip = ["Subsidiary Company", "Associate Company", "Investment"]
    const [allCompany, setAllCompany] = useState([]);
    const [projects, setProjects] = useState([]);
    const [relationType, setRelationType] = useState("");
    const history = useHistory();

    const [extraDetails, setExtraDetails] = useState([]);
    const [showConsoleEntry, setShowConsoleEntry] = useState(false);
    const [investmentData, setInvestmentData] = useState({
    investmentCompanyID: "",
    companyCode: "",
    dateOfInvestment: null,
    investmentValue: "",
    noOfSharesBought: "",
    totalNoOfSharesInTheCompany: "",
    percentageHolding: "",
    nonControllingInterest: "",
    natureOfRelationship: "",
    browseControlDateFS: "",
    detailsOfNetworthOnTheDateOfControl: "",
    isCommonControlTransaction: false,
    });

    useEffect(() => {
        getCompanyData();
        getUserBasedProjects();
    }, [])


    const getCompanyData = async () => {
        try {
            const res = await getCompany();
            if (res.status === 200) {
                setAllCompany(res.data.getCompany);
            }
        } catch (error) {
            console.log(error.message, "error");
        }
    };

    const getUserBasedProjects = async () => {
        GetProjectsBasedOnUserId(user_id).then(response => {
            setProjects(response.data?.result)
        }).catch(error => {
            console.log("error", error)
        })
    };

    const handleAddDetail = () => {
        setExtraDetails((prev) => [...prev, { field1: "", field2: "" }]);
    };

    const handleDetailChange = (index, field, value) => {
        setExtraDetails((prev) => {
            const updated = [...prev];
            updated[index] = { ...updated[index], [field]: value };
            return updated;
        });
    };

    const handleRemoveDetail = (index) => {
        setExtraDetails((prev) => prev.filter((_, i) => i !== index));
    };

    const handleChange = (field, value) => {
    setInvestmentData((prev) => ({
        ...prev,
        [field]: value,
    }));
    };

const handleSaveInvestment = async () => {

  if (!registerid) {
    alert("Register ID not found!");
    return;
  }

  console.log("✅ Register ID being used:", registerid);

  try {
    const payload = {
      investmentCompanyID: investmentData.investmentCompanyID,
      companyCode: investmentData.companyCode,
      dateOfInvestment: dayjs(investmentData.dateOfInvestment).format("DD-MM-YYYY"),
      investmentValue: Number(investmentData.investmentValue),
      noOfSharesBought: Number(investmentData.noOfSharesBought),
      totalNoOfSharesInTheCompany: Number(investmentData.totalNoOfSharesInTheCompany),
      percentageHolding: Number(investmentData.percentageHolding),
      nonControllingInterest: Number(investmentData.nonControllingInterest),
      natureOfRelationship: investmentData.natureOfRelationship,
      browseControlDateFS:
        relationType === "Subsidiary Company"
          ? investmentData.browseControlDateFS
          : null,

      addOtherDetails: extraDetails.map((d) => ({
        description: d.field1,
        amount: Number(d.field2),
      })),

      detailsOfNetworthOnTheDateOfControl:
        investmentData.detailsOfNetworthOnTheDateOfControl,

      isCommonControlTransaction: investmentData.isCommonControlTransaction,

      consolEntry: showConsoleEntry
        ? {
            nonControllingAsset: 0,
            investment: Number(investmentData.investmentValue),
            goodWill: 600000,
            otherInputs: 0,
          }
        : null,
    };

   
    const res = await createInvestmentObject(registerid, payload);

    if (res.data.success) {
      alert("Investment Created Successfully!");

      // ✅ Redirect with correct ID
      history.push(`/detailsIR/${registerid}`);
    }
  } catch (error) {
    console.error("❌ Error:", error.response?.data);
    alert(`Error: ${error.response?.data?.error || error.message}`);
  }
};


    return (
        <>
            <div className={commoncss.pageLayout}>
                <Sidebar />
                <div className={`d-flex ${commoncss.pageContent}`}>
                    <IRMenu
                        activeTab={"Investments"}
                        registerID={registerid}
                    />
                    <motion.div
                        initial={{ x: 200, opacity: 0 }}
                        animate={{ x: 0, opacity: 1 }}
                        exit={{ x: 200, opacity: 0 }}
                        transition={{ duration: 1, ease: "easeInOut" }}
                        className={investmentRegisterCss.irLayout}
                    >
                        <div className={investmentRegisterCss.iDHeader}>
                            <div style={{ display:"flex",alignItems:"center", gap:"15px", fontSize:"14px" }}>
                                <Link to={`/detailsIR/${registerid}`} style={{ textDecoration:"none"  }}>
                                    <span>
                                        <LeftArrowIcon height={12} style={{ marginBottom:"2px" }}/>
                                    </span>
                                    <span style={{ color:"#4D6D64", marginLeft:"10px"}}>
                                        Investments
                                    </span>
                                </Link>
                                <span>
                                    <DotIcon />
                                </span>
                                <span>  Create new investment </span>
                            </div>
                            <div className="d-flex" style={{ gap: "10px" }}>

                                <Button
                                    btnColor={buttoncss.greyBg}
                                    label="Cancel"
                                // onClick={handleOpen}
                                />
                                <Button
                                    btnColor={buttoncss.primary}
                                    label="Save Details"
                                    onClick={handleSaveInvestment}
                                // onClick={saveAllAdditionalIrsDetails}
                                />
                            </div>
                        </div>
                        <div className={investmentRegisterCss.investmentDataCtn}>
                            <div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <span className="input-label">Select Investment Company</span>
                                        <Select
                                            placeholder="Select Investment Company"
                                            name="investment_company_id"
                                            options={allCompany.map((det) => ({
                                                label: det.company_name,
                                                value: det._id,
                                            }))}
                                            onChange={(opt) =>
                                                handleChange("investmentCompanyID", opt.value)
                                            }
                                            className={`basic-multi-select w-100 mt-1 mb-2`}
                                            classNamePrefix="select"
                                            components={{
                                                ...animatedComponents,
                                                IndicatorSeparator: () => null,
                                                DropdownIndicator: CustomDropdownIndicator,
                                            }}
                                            styles={customStyles}
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <InputGroup
                                            label="Company code"
                                            inputs={[
                                                <>
                                                    <input
                                                        type="text"
                                                        value={investmentData.companyCode}
                                                        onChange={(e) =>
                                                            handleChange("companyCode", e.target.value)
                                                        }
                                                    />
                                                </>,
                                            ]}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <InputGroup
                                            label="Date of investment"
                                            inputs={[
                                                <>
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <DemoContainer components={["DatePicker", "MobileDatePicker"]}>
                                                            <MobileDatePicker
                                                                value={investmentData.dateOfInvestment}
                                                                onChange={(newValue) =>
                                                                    handleChange("dateOfInvestment", newValue)
                                                                }
                                                                className={`${commoncss.datePickerContainer} ${commoncss.clickable}`}
                                                                format="DD-MMM-YYYY"
                                                                slotProps={{
                                                                    textField: {
                                                                        InputProps: {
                                                                            disableUnderline: true,
                                                                        },
                                                                        inputProps: {
                                                                            placeholder: "DD-MM-YYYY",
                                                                        },
                                                                        sx: {
                                                                            '& fieldset': {
                                                                                border: 'none',
                                                                            },
                                                                        },
                                                                    },
                                                                }}
                                                            />

                                                        </DemoContainer>
                                                    </LocalizationProvider>
                                                    <span className="icon">
                                                        <CalenderIcon
                                                            className="vaMiddle"
                                                            width={20}
                                                            height={20}
                                                        />
                                                    </span>
                                                </>,
                                            ]}
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <InputGroup
                                            label=" Value of investment"
                                            inputs={[
                                                <>
                                                    <input
                                                        name="value_of_investment"
                                                        type="number"
                                                        value={investmentData.investmentValue}
                                                        onChange={(e) =>
                                                            handleChange("investmentValue", e.target.value)
                                                        }
                                                    />
                                                </>,
                                            ]}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <InputGroup
                                            label=" No of shares bought"
                                            inputs={[
                                                <>
                                                    <input
                                                        type="number"
                                                        value={investmentData.noOfSharesBought}
                                                        onChange={(e) =>
                                                            handleChange("noOfSharesBought", e.target.value)
                                                        }
                                                    />
                                                </>,
                                            ]}
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <InputGroup
                                            label="Total no shares in the company"
                                            inputs={[
                                                <>
                                                    <input
                                                        type="number"
                                                        value={investmentData.totalNoOfSharesInTheCompany}
                                                        onChange={(e) =>
                                                            handleChange("totalNoOfSharesInTheCompany", e.target.value)
                                                        }
                                                                                                        />
                                                </>,
                                            ]}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <InputGroup
                                            label="Percentage holding"
                                            inputs={[
                                                <>
                                                    <input
                                                       type="number"
                                                        value={investmentData.percentageHolding}
                                                        onChange={(e) =>
                                                            handleChange("percentageHolding", e.target.value)
                                                        }
                                                    />
                                                </>,
                                            ]}
                                        />

                                    </div>
                                    <div className="col-md-6">
                                        <InputGroup
                                            label="Non-controling interest Percentage"
                                            inputs={[
                                                <>
                                                    <input
                                                        type="number"
                                                        value={investmentData.nonControllingInterest}
                                                        onChange={(e) =>
                                                            handleChange("nonControllingInterest", e.target.value)
                                                        }

                                                    />
                                                </>,
                                            ]}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <span className="input-label">Nature of relationship</span>
                                        <Select
                                            placeholder="Nature of relationship"
                                            name="nature_of_relationship"
                                            options={companyRelationShip.map((nr) => ({
                                                label: nr,
                                                value: nr,
                                            }))}
                                            className={`basic-multi-select w-100 mt-1 mb-2`}
                                            classNamePrefix="select"
                                            components={{
                                                ...animatedComponents,
                                                IndicatorSeparator: () => null,
                                                DropdownIndicator: CustomDropdownIndicator,
                                            }}
                                            styles={customStyles}
                                            onChange={(opt) => {
                                                setRelationType(opt.value);
                                                handleChange("natureOfRelationship", opt.value);
                                            }}
  
                                        />
                                    </div>
                                </div>
                                {relationType === "Subsidiary Company" && (
                                    <>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <span className="input-label">Browse control date FS</span>
                                                <Select
                                                    placeholder="Select"
                                                     options={projects.map((project) => ({
                                                     label: project.project_name,
                                                     value: project._id,
                                                    }))}
                                                    onChange={(opt) =>
                                                        handleChange("browseControlDateFS", opt.value)
                                                    }
                                                    className={`basic-multi-select w-100 mt-1 mb-2`}
                                                    classNamePrefix="select"
                                                    components={{
                                                        ...animatedComponents,
                                                        IndicatorSeparator: () => null,
                                                        DropdownIndicator: CustomDropdownIndicator,
                                                    }}
                                                    styles={customStyles}
                                                />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <InputGroup
                                                    label="Details of net-worth on the date of control"
                                                    inputs={[
                                                        <>
                                                            <input
                                                                type="text"
                                                                value={investmentData.detailsOfNetworthOnTheDateOfControl}
                                                                onChange={(e) =>
                                                                    handleChange(
                                                                    "detailsOfNetworthOnTheDateOfControl",
                                                                    e.target.value
                                                                    )
                                                                }
                                                            />
                                                        </>,
                                                    ]}
                                                />
                                            </div>
                                        </div>

                                        <div>
                                            <div className={investmentRegisterCss.radioButtonSection}>
                                                <span className="input-label" style={{ fontSize: "15px" }}>Add Other details</span>
                                                <span
                                                    className="input-label"
                                                    style={{ display: "flex", alignItems: "center", gap: "5px", fontSize: "15px", cursor: "pointer" }}
                                                    onClick={() => handleAddDetail()}
                                                >
                                                    <PlusPrimaryIcon />
                                                    Add Details
                                                </span>
                                            </div>
                                            {extraDetails.map((detail, index) => (
                                                <div
                                                    key={index}
                                                    style={{
                                                        display: "flex",
                                                        gap: "10px",
                                                        marginTop: "10px",
                                                        alignItems: "center",
                                                    }}
                                                >   <div className="col-md-5">
                                                        <InputGroup
                                                            inputs={[
                                                                <>
                                                                    <input
                                                                        type="text"
                                                                        placeholder="Type Something..."
                                                                        value={detail.field1 || ""}
                                                                        onChange={(e) =>
                                                                            handleDetailChange(index, "field1", e.target.value)
                                                                        }
                                                                    />
                                                                </>,
                                                            ]}
                                                        />
                                                    </div>
                                                    <div className="col-md-5">
                                                        <InputGroup
                                                            inputs={[
                                                                <>
                                                                    <input
                                                                        type="text"
                                                                        placeholder="Enter Amount..."
                                                                        value={detail.field2 || ""}
                                                                        onChange={(e) =>
                                                                            handleDetailChange(index, "field2", e.target.value)
                                                                        }
                                                                    />
                                                                </>,
                                                            ]}
                                                        />
                                                    </div>
                                                    <div className="col-md-2">
                                                        <span>
                                                            <CrossGreyIcon
                                                                onClick={() => handleRemoveDetail(index)}
                                                            />
                                                        </span>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>

                                        <div className="row mt-3">
                                            <div className="col-md-4">
                                                <button className={investmentRegisterCss.consoleBtn} onClick={() => setShowConsoleEntry(true)}>
                                                    Create consol entry
                                                </button>
                                            </div>
                                        </div>
                                        {showConsoleEntry && (
                                            <div>
                                                <div className={investmentRegisterCss.consoleEntryHeading}>Console Entry</div>
                                                <div className={investmentRegisterCss.consoleEntryCard}>
                                                    <div className={investmentRegisterCss.consoleEntryItem}>
                                                        <span style={{ color:"#4D6D64" }}>Non-controlling Asset</span>
                                                        <span>0</span>
                                                    </div>
                                                    <div className={investmentRegisterCss.consoleEntryItem}>
                                                        <span style={{ color:"#4D6D64" }}>Investment</span>
                                                        <span>{investmentData.investmentValue || 0}</span>
                                                    </div>
                                                    <div className={investmentRegisterCss.consoleEntryItem}>
                                                        <span style={{ color:"#4D6D64" }}>Good will</span>
                                                        <span>{showConsoleEntry ? 60000 : 0}</span>
                                                    </div>
                                                    <div className={investmentRegisterCss.consoleEntryItem}>
                                                        <span style={{ color:"#4D6D64" }}>Other Inputs</span>
                                                        <span>-1000</span>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </>
                                )}
                                <div className="row">
                                    <div className={`${investmentRegisterCss.radioButtonSection} col-md-12`}>
                                        <span className="input-label" style={{ fontSize: "15px" }}>Is the transaction covered as common control transaction?</span>
                                        <span>
                                            <RadioGroup
                                                row
                                                aria-labelledby="demo-row-radio-buttons-group-label"
                                                name="control-transaction"
                                                value={investmentData.isCommonControlTransaction ? "yes" : "no"}
                                                onChange={(e) =>
                                                    handleChange(
                                                    "isCommonControlTransaction",
                                                    e.target.value === "yes"
                                                    )
                                                }
                                                className={investmentRegisterCss.radioSection}
                                            >
                                                <FormControlLabel
                                                    value="yes"
                                                    label="Yes"
                                                    className={investmentRegisterCss.radioLabel}
                                                    control={
                                                        <Radio
                                                            sx={{
                                                                "& .MuiSvgIcon-root": {
                                                                    fontSize: 18,
                                                                },
                                                                color: "#D6D6D6",
                                                                "&.Mui-checked": { color: "#3AB67D" },
                                                            }}
                                                        />
                                                    }
                                                />
                                                <FormControlLabel
                                                    value="no"
                                                    label="No"
                                                    className={investmentRegisterCss.radioLabel}
                                                    control={
                                                        <Radio
                                                            sx={{
                                                                "& .MuiSvgIcon-root": {
                                                                    fontSize: 18,
                                                                },
                                                                color: "#D6D6D6",
                                                                "&.Mui-checked": { color: "#3AB67D" },
                                                            }}
                                                        />
                                                    }
                                                />
                                            </RadioGroup>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </motion.div>
                </div>
            </div>
        </>
    )
}

export default CreateInvestment;